var _circle, _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupportinline = function SvgSupportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00877C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    fill: "#fff",
    rx: 19,
    ry: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44 48v-8l-12 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00877C",
    d: "M29.712 35.39v-.35c0-.97.08-1.742.24-2.317.165-.576.404-1.038.718-1.386a5.52 5.52 0 0 1 1.146-.966c.36-.228.679-.459.958-.693.285-.239.51-.496.676-.77.165-.273.248-.584.248-.931 0-.337-.08-.633-.24-.89a1.573 1.573 0 0 0-.658-.59 1.951 1.951 0 0 0-.915-.213c-.337 0-.653.077-.95.23-.29.154-.53.374-.718.659-.183.28-.277.618-.283 1.018H26c.017-1.198.294-2.178.83-2.942a4.812 4.812 0 0 1 2.147-1.693c.889-.37 1.87-.556 2.942-.556 1.174 0 2.218.182 3.13.547.918.365 1.64.904 2.164 1.616.525.713.787 1.585.787 2.617 0 .678-.114 1.277-.342 1.796a4.34 4.34 0 0 1-.958 1.377c-.405.393-.881.752-1.428 1.077-.428.25-.785.513-1.07.787a2.74 2.74 0 0 0-.633.94c-.142.348-.213.776-.213 1.283v.35h-3.644m1.89 5.61a2.172 2.172 0 0 1-1.582-.65 2.113 2.113 0 0 1-.642-1.573 2.065 2.065 0 0 1 .642-1.548c.439-.433.966-.65 1.582-.65.588 0 1.104.217 1.548.65a2.098 2.098 0 0 1 .351 2.668 2.333 2.333 0 0 1-.812.804c-.331.2-.693.299-1.087.299"
  })));
};
export default SvgSupportinline;